var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminAssignment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.028 163.687C232.421 124.366 234.495 68.7993 206.24 34.2792C190.656 15.2428 166.137 8.91338 142.73 7.50095C121.755 6.23314 99.3003 6.7393 80.243 16.795C47.9384 33.8405 47.1437 74.3719 22.9474 98.2867C3.43325 117.569 -4.656 145.046 11.9983 181.2C28.6527 217.355 59.5821 225.55 90.0358 213.98C120.489 202.411 134.289 200.001 170.928 205.785C187.768 208.446 199.988 195.643 207.377 181.851C210.547 175.936 213.449 169.877 216.028 163.692V163.687Z",
    fill: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M216.028 163.687C232.421 124.366 234.495 68.7993 206.24 34.2792C190.656 15.2428 166.137 8.91338 142.73 7.50095C121.755 6.23314 99.3003 6.7393 80.243 16.795C47.9384 33.8405 47.1437 74.3719 22.9474 98.2867C3.43325 117.569 -4.656 145.046 11.9983 181.2C28.6527 217.355 59.5821 225.55 90.0358 213.98C120.489 202.411 134.289 200.001 170.928 205.785C187.768 208.446 199.988 195.643 207.377 181.851C210.547 175.936 213.449 169.877 216.028 163.692V163.687Z",
    fill: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5933 8.23389H71.7681V36.6029H45.2544",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.485 36.6029H36.0374V8.23389H47.8287",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6563 16.4673H38.7354V20.4394H42.6563V16.4673Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9381 16.4673H44.0172V20.4394H47.9381V16.4673Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2247 16.4673H49.3038V20.4394H53.2247V16.4673Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5065 16.4673H54.5856V20.4394H58.5065V16.4673Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7883 16.4673H59.8674V20.4394H63.7883V16.4673Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 16.4673H65.1492V20.4394H69.0701V16.4673Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6563 21.9917H38.7354V25.9638H42.6563V21.9917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9381 21.9917H44.0172V25.9638H47.9381V21.9917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2247 21.9917H49.3038V25.9638H53.2247V21.9917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5065 21.9917H54.5856V25.9638H58.5065V21.9917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7883 21.9917H59.8674V25.9638H63.7883V21.9917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 21.9917H65.1492V25.9638H69.0701V21.9917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6563 27.5161H38.7354V31.4883H42.6563V27.5161Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9381 27.5161H44.0172V31.4883H47.9381V27.5161Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2247 27.5161H49.3038V31.4883H53.2247V27.5161Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5065 27.5161H54.5856V31.4883H58.5065V27.5161Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7883 27.5161H59.8674V31.4883H63.7883V27.5161Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0701 27.5161H65.1492V31.4883H69.0701V27.5161Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2224 12.1479H38.8877V13.5266H69.2224V12.1479Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.24 40.6572H219.601V69.0263H216.128",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.758 69.0263H183.871V40.6572H203.076",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49 48.8906H186.569V52.8628H190.49V48.8906Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.771 48.8906H191.851V52.8628H195.771V48.8906Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.053 48.8906H197.132V52.8628H201.053V48.8906Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.335 48.8906H202.414V52.8628H206.335V48.8906Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.622 48.8906H207.701V52.8628H211.622V48.8906Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.903 48.8906H212.983V52.8628H216.903V48.8906Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49 54.415H186.569V58.3872H190.49V54.415Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.771 54.415H191.851V58.3872H195.771V54.415Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.053 54.415H197.132V58.3872H201.053V54.415Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.335 54.415H202.414V58.3872H206.335V54.415Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.622 54.415H207.701V58.3872H211.622V54.415Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.903 54.415H212.983V58.3872H216.903V54.415Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49 59.9395H186.569V63.9116H190.49V59.9395Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.771 59.9395H191.851V63.9116H195.771V59.9395Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.053 59.9395H197.132V63.9116H201.053V59.9395Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.335 59.9395H202.414V63.9116H206.335V59.9395Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.622 59.9395H207.701V63.9116H211.622V59.9395Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.903 59.9395H212.983V63.9116H216.903V59.9395Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.051 44.5762H186.716V45.9597H217.051V44.5762Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3743 86.0282V71.2194C18.3743 70.2023 19.188 69.3779 20.192 69.3779H43.018C44.022 69.3779 44.8357 70.2023 44.8357 71.2194V92.5022H18.3696V89.2339",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7074 74.4058H44.5074",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8838 78.7637H21.02V81.7765H42.1948V78.7637H28.838",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.19 85.1313H21.02V88.149H42.19V85.1313Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.736 193.749H150.562C151.566 193.749 152.38 194.573 152.38 195.59V216.873H125.914V195.59C125.914 194.573 126.727 193.749 127.731 193.749H127.736Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.247 198.777H152.047",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.729 203.135H128.559V206.152H149.729V203.135Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.729 209.502H128.559V212.52H149.729V209.502Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.842 13.3052C130.22 10.9094 126.746 9.44873 122.94 9.44873C114.779 9.44873 108.16 16.1541 108.16 24.4214C108.16 28.543 109.802 32.2693 112.457 34.9785",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.142 36.4537C116.602 38.2999 119.642 39.3942 122.94 39.3942C131.1 39.3942 137.719 32.6888 137.719 24.4215C137.719 20.6277 136.325 17.1618 134.032 14.5249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.701 24.4214H122.94V36.0534",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3363 34.7808C14.7722 35.3351 12.0457 38.4589 12.0457 42.2237C12.0457 46.3839 15.3718 49.7534 19.4783 49.7534C20.3966 49.7534 21.2769 49.5847 22.0859 49.2762",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4984 47.7723C25.9782 46.3936 26.9061 44.4172 26.9061 42.2238C26.9061 38.377 24.0558 35.2051 20.3824 34.752",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4735 38.3867V46.0562",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2612 42.2241H15.6906",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.478 108.425C223.583 108.425 226.91 105.054 226.91 100.895C226.91 96.7364 223.583 93.3652 219.478 93.3652C215.373 93.3652 212.045 96.7364 212.045 100.895C212.045 105.054 215.373 108.425 219.478 108.425Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.478 97.0576V104.732",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.265 100.895H215.69",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.664 201.447H34.8383L35.0382 58.985C35.0382 56.1264 37.3222 53.8125 40.1439 53.8125H200.758C203.58 53.8125 205.864 56.1264 205.864 58.985L205.664 201.447Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.813 66.4712H57.5596V71.528H81.813V66.4712Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34 73.3599H199.573",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5216 73.3599H152.76",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.763 53.8125H40.1439C37.3222 53.8125 35.0382 56.1264 35.0382 58.985V62.9234H205.864V58.985C205.864 56.1264 203.58 53.8125 200.758 53.8125H200.763Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3456 58.8695C44.3456 58.0066 43.6556 57.3076 42.8038 57.3076C41.9521 57.3076 41.2621 58.0066 41.2621 58.8695C41.2621 59.7324 41.9521 60.4313 42.8038 60.4313C43.6556 60.4313 44.3456 59.7324 44.3456 58.8695Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5077 58.8695C50.5077 58.0066 49.8177 57.3076 48.9659 57.3076C48.1142 57.3076 47.4242 58.0066 47.4242 58.8695C47.4242 59.7324 48.1142 60.4313 48.9659 60.4313C49.8177 60.4313 50.5077 59.7324 50.5077 58.8695Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1281 60.4313C55.9795 60.4313 56.6698 59.7321 56.6698 58.8695C56.6698 58.0069 55.9795 57.3076 55.1281 57.3076C54.2766 57.3076 53.5863 58.0069 53.5863 58.8695C53.5863 59.7321 54.2766 60.4313 55.1281 60.4313Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8975 66.77H52.2112",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8975 68.7559H52.2112",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8975 70.7471H52.2112",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2537 84.3312V77.9487H44.9642V77.2305H48.3283V77.9487H47.0388V84.3312H46.2584H46.2537Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2752 82.9043L49.004 84.336H48.2855L49.6274 77.2354H50.7599L52.1017 84.336H51.3213L51.0501 82.9043H49.28H49.2752ZM49.3752 82.2246H50.9359L50.146 78.1272L49.3752 82.2246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7466 78.9371V79.1299H55.0043V78.8986C55.0043 78.2574 54.7664 77.8862 54.2049 77.8862C53.6434 77.8862 53.4055 78.2622 53.4055 78.8889C53.4055 80.4797 55.7562 80.634 55.7562 82.6297C55.7562 83.7047 55.247 84.4036 54.1764 84.4036C53.1057 84.4036 52.6061 83.7047 52.6061 82.6297V82.2247H53.3389V82.6731C53.3389 83.3142 53.6006 83.6854 54.1621 83.6854C54.7236 83.6854 54.9805 83.3094 54.9805 82.6731C54.9805 81.0919 52.6394 80.9377 52.6394 78.9419C52.6394 77.8477 53.139 77.168 54.1907 77.168C55.2423 77.168 55.7514 77.867 55.7514 78.9419L55.7466 78.9371Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6262 81.2509L57.217 81.9499V84.336H56.4366V77.2354H57.217V80.6628L59.0775 77.2354H59.8674L58.0973 80.47L59.9293 84.336H59.1299L57.6262 81.2509Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5171 78.9371V79.1299H62.7748V78.8986C62.7748 78.2574 62.5369 77.8862 61.9754 77.8862C61.4139 77.8862 61.176 78.2622 61.176 78.8889C61.176 80.4797 63.5266 80.634 63.5266 82.6297C63.5266 83.7047 63.0175 84.4036 61.9468 84.4036C60.8762 84.4036 60.3766 83.7047 60.3766 82.6297V82.2247H61.1093V82.6731C61.1093 83.3142 61.3711 83.6854 61.9325 83.6854C62.494 83.6854 62.751 83.3094 62.751 82.6731C62.751 81.0919 60.4099 80.9377 60.4099 78.9419C60.4099 77.8477 60.9095 77.168 61.9611 77.168C63.0127 77.168 63.5218 77.867 63.5218 78.9419L63.5171 78.9371Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.137 124.198H44.6406V153.295H152.137V124.198Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.474 131.785C127.946 131.785 128.145 132.064 128.145 132.527V132.893C128.145 133.375 127.922 133.626 127.446 133.626H127.151V134.822H126.818V131.785H127.474ZM127.451 133.322C127.698 133.322 127.817 133.207 127.817 132.913V132.508C127.817 132.228 127.717 132.093 127.474 132.093H127.156V133.322H127.451Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.078 131.785C129.549 131.785 129.744 132.026 129.744 132.479V132.725C129.744 133.058 129.63 133.265 129.373 133.352C129.649 133.434 129.749 133.66 129.749 133.983V134.456C129.749 134.591 129.749 134.716 129.811 134.822H129.473C129.435 134.735 129.416 134.658 129.416 134.451V133.974C129.416 133.631 129.259 133.52 128.978 133.52H128.74V134.817H128.407V131.78H129.073L129.078 131.785ZM128.992 133.217C129.259 133.217 129.416 133.13 129.416 132.802V132.513C129.416 132.238 129.316 132.098 129.069 132.098H128.745V133.222H128.992V133.217Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.073 132.518C130.073 132.055 130.301 131.756 130.758 131.756C131.215 131.756 131.448 132.055 131.448 132.518V134.09C131.448 134.547 131.219 134.851 130.758 134.851C130.296 134.851 130.073 134.547 130.073 134.09V132.518ZM130.401 134.109C130.401 134.388 130.515 134.547 130.758 134.547C131 134.547 131.115 134.388 131.115 134.109V132.504C131.115 132.229 131.005 132.065 130.758 132.065C130.51 132.065 130.401 132.229 130.401 132.504V134.109Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.085 132.518V132.778H132.766V132.499C132.766 132.224 132.661 132.06 132.414 132.06C132.166 132.06 132.062 132.224 132.062 132.499V134.104C132.062 134.379 132.171 134.543 132.414 134.543C132.656 134.543 132.766 134.379 132.766 134.104V133.497H132.456V133.193H133.08V134.085C133.08 134.543 132.866 134.846 132.404 134.846C131.943 134.846 131.733 134.543 131.733 134.085V132.513C131.733 132.055 131.947 131.751 132.404 131.751C132.861 131.751 133.08 132.055 133.08 132.513L133.085 132.518Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.07 131.785C134.541 131.785 134.736 132.026 134.736 132.479V132.725C134.736 133.058 134.622 133.265 134.365 133.352C134.641 133.434 134.741 133.66 134.741 133.983V134.456C134.741 134.591 134.741 134.716 134.802 134.822H134.465C134.426 134.735 134.407 134.658 134.407 134.451V133.974C134.407 133.631 134.25 133.52 133.97 133.52H133.732V134.817H133.399V131.78H134.065L134.07 131.785ZM133.984 133.217C134.25 133.217 134.407 133.13 134.407 132.802V132.513C134.407 132.238 134.307 132.098 134.06 132.098H133.736V133.222H133.984V133.217Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.159 133.13V133.433H135.426V134.513H136.325V134.822H135.093V131.785H136.325V132.093H135.426V133.13H136.159Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.929 132.518V132.6H137.61V132.499C137.61 132.224 137.505 132.065 137.267 132.065C137.029 132.065 136.925 132.224 136.925 132.494C136.925 133.174 137.933 133.241 137.933 134.094C137.933 134.552 137.714 134.856 137.258 134.856C136.801 134.856 136.587 134.557 136.587 134.094V133.921H136.901V134.114C136.901 134.388 137.01 134.547 137.253 134.547C137.496 134.547 137.605 134.388 137.605 134.114C137.605 133.439 136.601 133.371 136.601 132.518C136.601 132.05 136.815 131.756 137.267 131.756C137.719 131.756 137.933 132.055 137.933 132.518H137.929Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.523 132.518V132.6H139.204V132.499C139.204 132.224 139.099 132.065 138.861 132.065C138.623 132.065 138.519 132.224 138.519 132.494C138.519 133.174 139.527 133.241 139.527 134.094C139.527 134.552 139.309 134.856 138.852 134.856C138.395 134.856 138.181 134.557 138.181 134.094V133.921H138.495V134.114C138.495 134.388 138.604 134.547 138.847 134.547C139.09 134.547 139.199 134.388 139.199 134.114C139.199 133.439 138.195 133.371 138.195 132.518C138.195 132.05 138.409 131.756 138.861 131.756C139.313 131.756 139.527 132.055 139.527 132.518H139.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 131.785C106.457 131.785 106.671 132.069 106.671 132.542V134.074C106.671 134.537 106.457 134.826 105.99 134.826H105.286V131.789H105.99V131.785ZM105.986 134.518C106.224 134.518 106.342 134.364 106.342 134.089V132.527C106.342 132.247 106.228 132.098 105.981 132.098H105.619V134.518H105.981H105.986Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.051 133.13V133.433H107.318V134.513H108.217V134.822H106.985V131.785H108.217V132.093H107.318V133.13H108.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.864 134.214L108.75 134.827H108.441L109.017 131.79H109.502L110.078 134.827H109.745L109.631 134.214H108.874H108.864ZM108.907 133.92H109.573L109.236 132.166L108.907 133.92Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.039 131.785C111.505 131.785 111.719 132.069 111.719 132.542V134.074C111.719 134.537 111.505 134.826 111.039 134.826H110.335V131.789H111.039V131.785ZM111.034 134.518C111.272 134.518 111.391 134.364 111.391 134.089V132.527C111.391 132.247 111.277 132.098 111.029 132.098H110.668V134.518H111.029H111.034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.029 134.827V131.79H112.362V134.518H113.218V134.827H112.029Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.808 131.785V134.822H113.475V131.785H113.808Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.446 134.827H114.146V131.79H114.57L115.264 133.988V131.79H115.559V134.827H115.212L114.446 132.368V134.827Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.968 133.13V133.433H116.235V134.513H117.134V134.822H115.902V131.785H117.134V132.093H116.235V133.13H116.968Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2859 135.256H92.5432",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5094 135.256H84.0305",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 135.256H65.0017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0214 142.472H81.8083",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7543 142.472H73.0148",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7444 142.472H62.2513",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 142.472H56.7411",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.154 141.127C148.154 141.754 147.902 142.323 147.498 142.733C147.093 143.142 146.527 143.403 145.908 143.403H122.331C121.089 143.403 120.08 142.381 120.08 141.127C120.08 140.496 120.332 139.927 120.741 139.517C121.146 139.103 121.707 138.847 122.331 138.847H145.908C147.15 138.847 148.154 139.869 148.154 141.127Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.126 138.847V143.403H122.331C121.089 143.403 120.08 142.381 120.08 141.127C120.08 140.496 120.332 139.927 120.741 139.517C121.146 139.103 121.707 138.847 122.331 138.847H141.126Z",
    fill: "#F8F2AD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.617 138.847H106.309C105.069 138.847 104.063 139.866 104.063 141.122V141.127C104.063 142.384 105.069 143.403 106.309 143.403H115.617C116.857 143.403 117.863 142.384 117.863 141.127V141.122C117.863 139.866 116.857 138.847 115.617 138.847Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.137 161.321H44.6406V190.418H152.137V161.321Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.474 169.525C127.946 169.525 128.145 169.804 128.145 170.267V170.634C128.145 171.116 127.922 171.366 127.446 171.366H127.151V172.562H126.818V169.525H127.474ZM127.451 171.058C127.698 171.058 127.817 170.942 127.817 170.648V170.243C127.817 169.964 127.717 169.829 127.474 169.829H127.156V171.058H127.451Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.078 169.525C129.549 169.525 129.744 169.766 129.744 170.219V170.465C129.744 170.798 129.63 171.005 129.373 171.092C129.649 171.174 129.749 171.401 129.749 171.723V172.196C129.749 172.331 129.749 172.456 129.811 172.562H129.473C129.435 172.476 129.416 172.398 129.416 172.191V171.714C129.416 171.372 129.259 171.261 128.978 171.261H128.74V172.557H128.407V169.521H129.073L129.078 169.525ZM128.992 170.957C129.259 170.957 129.416 170.87 129.416 170.542V170.253C129.416 169.978 129.316 169.839 129.069 169.839H128.745V170.962H128.992V170.957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.073 170.258C130.073 169.795 130.301 169.497 130.758 169.497C131.215 169.497 131.448 169.795 131.448 170.258V171.83C131.448 172.288 131.219 172.591 130.758 172.591C130.296 172.591 130.073 172.288 130.073 171.83V170.258ZM130.401 171.844C130.401 172.124 130.515 172.283 130.758 172.283C131 172.283 131.115 172.124 131.115 171.844V170.239C131.115 169.964 131.005 169.8 130.758 169.8C130.51 169.8 130.401 169.964 130.401 170.239V171.844Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.085 170.258V170.518H132.766V170.239C132.766 169.964 132.661 169.8 132.414 169.8C132.166 169.8 132.062 169.964 132.062 170.239V171.844C132.062 172.119 132.171 172.283 132.414 172.283C132.656 172.283 132.766 172.119 132.766 171.844V171.237H132.456V170.933H133.08V171.825C133.08 172.283 132.866 172.587 132.404 172.587C131.943 172.587 131.733 172.283 131.733 171.825V170.253C131.733 169.795 131.947 169.492 132.404 169.492C132.861 169.492 133.08 169.795 133.08 170.253L133.085 170.258Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.07 169.525C134.541 169.525 134.736 169.766 134.736 170.219V170.465C134.736 170.798 134.622 171.005 134.365 171.092C134.641 171.174 134.741 171.401 134.741 171.723V172.196C134.741 172.331 134.741 172.456 134.802 172.562H134.465C134.426 172.476 134.407 172.398 134.407 172.191V171.714C134.407 171.372 134.25 171.261 133.97 171.261H133.732V172.557H133.399V169.521H134.065L134.07 169.525ZM133.984 170.957C134.25 170.957 134.407 170.87 134.407 170.542V170.253C134.407 169.978 134.307 169.839 134.06 169.839H133.736V170.962H133.984V170.957Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.159 170.87V171.174H135.426V172.253H136.325V172.562H135.093V169.525H136.325V169.833H135.426V170.87H136.159Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.929 170.253V170.335H137.61V170.234C137.61 169.959 137.505 169.8 137.267 169.8C137.029 169.8 136.925 169.959 136.925 170.229C136.925 170.909 137.933 170.976 137.933 171.83C137.933 172.288 137.714 172.591 137.258 172.591C136.801 172.591 136.587 172.292 136.587 171.83V171.656H136.901V171.849C136.901 172.124 137.01 172.283 137.253 172.283C137.496 172.283 137.605 172.124 137.605 171.849C137.605 171.174 136.601 171.107 136.601 170.253C136.601 169.786 136.815 169.492 137.267 169.492C137.719 169.492 137.933 169.791 137.933 170.253H137.929Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.523 170.253V170.335H139.204V170.234C139.204 169.959 139.099 169.8 138.861 169.8C138.623 169.8 138.519 169.959 138.519 170.229C138.519 170.909 139.527 170.976 139.527 171.83C139.527 172.288 139.309 172.591 138.852 172.591C138.395 172.591 138.181 172.292 138.181 171.83V171.656H138.495V171.849C138.495 172.124 138.604 172.283 138.847 172.283C139.09 172.283 139.199 172.124 139.199 171.849C139.199 171.174 138.195 171.107 138.195 170.253C138.195 169.786 138.409 169.492 138.861 169.492C139.313 169.492 139.527 169.791 139.527 170.253H139.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 169.525C106.457 169.525 106.671 169.809 106.671 170.282V171.815C106.671 172.277 106.457 172.567 105.99 172.567H105.286V169.53H105.99V169.525ZM105.986 172.253C106.224 172.253 106.342 172.099 106.342 171.824V170.262C106.342 169.983 106.228 169.833 105.981 169.833H105.619V172.253H105.981H105.986Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.051 170.87V171.174H107.318V172.253H108.217V172.562H106.985V169.525H108.217V169.833H107.318V170.87H108.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.864 171.95L108.75 172.562H108.441L109.017 169.525H109.502L110.078 172.562H109.745L109.631 171.95H108.874H108.864ZM108.907 171.66H109.573L109.236 169.906L108.907 171.66Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.039 169.525C111.505 169.525 111.719 169.809 111.719 170.282V171.815C111.719 172.277 111.505 172.567 111.039 172.567H110.335V169.53H111.039V169.525ZM111.034 172.253C111.272 172.253 111.391 172.099 111.391 171.824V170.262C111.391 169.983 111.277 169.833 111.029 169.833H110.668V172.253H111.029H111.034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.029 172.562V169.525H112.362V172.253H113.218V172.562H112.029Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.808 169.525V172.562H113.475V169.525H113.808Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.446 172.562H114.146V169.525H114.57L115.264 171.723V169.525H115.559V172.562H115.212L114.446 170.103V172.562Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.968 170.87V171.174H116.235V172.253H117.134V172.562H115.902V169.525H117.134V169.833H116.235V170.87H116.968Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2859 172.996H92.5432",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5094 172.996H84.0305",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 172.996H65.0017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0214 180.212H81.8083",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7543 180.212H73.0148",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7444 180.212H62.2513",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 180.212H56.7411",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.154 178.863C148.154 179.494 147.902 180.063 147.498 180.473C147.088 180.883 146.527 181.138 145.908 181.138H122.331C121.089 181.138 120.08 180.121 120.08 178.863C120.08 178.231 120.332 177.662 120.741 177.253C121.146 176.843 121.707 176.587 122.331 176.587H145.908C147.15 176.587 148.154 177.605 148.154 178.863Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.572 176.587V181.138H122.331C121.089 181.138 120.08 180.121 120.08 178.863C120.08 178.231 120.332 177.662 120.741 177.253C121.146 176.843 121.707 176.587 122.331 176.587H124.572Z",
    fill: "#F8F2AD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.617 181.138H106.314C105.072 181.138 104.068 180.116 104.068 178.863C104.068 177.605 105.077 176.587 106.314 176.587H115.617C116.859 176.587 117.863 177.609 117.863 178.863C117.863 180.121 116.854 181.138 115.617 181.138Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.726 87.084H161.121C159.881 87.084 158.875 88.1027 158.875 89.3593V100.128C158.875 101.385 159.881 102.404 161.121 102.404H198.726C199.967 102.404 200.972 101.385 200.972 100.128V89.3593C200.972 88.1027 199.967 87.084 198.726 87.084Z",
    fill: "#F8F2AD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.945 97.2071L166.674 98.6388H165.955L167.297 91.5381H168.43L169.772 98.6388H168.991L168.72 97.2071H166.95H166.945ZM167.045 96.5274H168.606L167.816 92.4299L167.045 96.5274Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.022 91.5381C173.112 91.5381 173.616 92.2081 173.616 93.3024V96.8841C173.616 97.9687 173.117 98.6388 172.022 98.6388H170.381V91.5381H172.022ZM172.013 97.9205C172.574 97.9205 172.846 97.5638 172.846 96.9178V93.2639C172.846 92.6131 172.574 92.2612 172.003 92.2612H171.161V97.9205H172.013Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.986 91.5381C177.076 91.5381 177.58 92.2081 177.58 93.3024V96.8841C177.58 97.9687 177.081 98.6388 175.986 98.6388H174.345V91.5381H175.986ZM175.977 97.9205C176.538 97.9205 176.809 97.5638 176.809 96.9178V93.2639C176.809 92.6131 176.538 92.2612 175.967 92.2612H175.125V97.9205H175.977Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.883 98.6388V92.2564H179.593V91.5381H182.957V92.2564H181.668V98.6388H180.887H180.883Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.909 97.2071L183.638 98.6388H182.919L184.261 91.5381H185.393L186.735 98.6388H185.955L185.684 97.2071H183.914H183.909ZM184.009 96.5274H185.57L184.78 92.4299L184.009 96.5274Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.375 93.2399V93.4327H189.633V93.2013C189.633 92.5602 189.395 92.189 188.834 92.189C188.272 92.189 188.034 92.565 188.034 93.1916C188.034 94.7824 190.385 94.9367 190.385 96.9324C190.385 98.0074 189.876 98.7064 188.805 98.7064C187.735 98.7064 187.235 98.0074 187.235 96.9324V96.5275H187.968V96.9758C187.968 97.6169 188.229 97.9881 188.791 97.9881C189.352 97.9881 189.609 97.6121 189.609 96.9758C189.609 95.3946 187.268 95.2404 187.268 93.2447C187.268 92.1504 187.768 91.4707 188.82 91.4707C189.871 91.4707 190.38 92.1697 190.38 93.2447L190.375 93.2399Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.26 95.5536L191.851 96.2526V98.6388H191.07V91.5381H191.851V94.9655L193.711 91.5381H194.501L192.731 94.7727L194.563 98.6388H193.763L192.26 95.5536Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89 26.0363C164.89 26.0363 159.36 28.5044 156.482 29.2854C153.607 30.0711 150.51 31.3052 149.734 33.7685C148.959 36.2318 145.504 45.709 145.285 47.7289C145.066 49.7487 148.63 53.3834 148.63 53.3834H194.653C194.653 53.3834 195.505 41.5875 193.625 37.5526C191.746 33.5178 186.022 30.0711 184.366 29.4011C182.705 28.731 178.394 26.6003 176.624 26.2629C174.854 25.9254 166.888 25.2554 164.899 26.0363H164.89Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.634 42.3685C149.634 42.3685 152.327 41.4044 154.868 43.3326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.634 42.3685C149.634 42.3685 152.327 41.4044 154.868 43.3326",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.322 43.3325C153.322 43.3325 154.868 43.3325 156.177 44.5377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.322 43.3325C153.322 43.3325 154.868 43.3325 156.177 44.5377",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.023 37.9478C158.399 38.5841 158.666 39.4132 158.575 40.4352C158.337 43.2311 157.409 45.2557 157.409 45.2557",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.42 36.3184C156.42 36.3184 157.01 36.6462 157.571 37.3114",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.241 37.8125C159.241 37.8125 160.126 40.5265 159.627 42.7198",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.148 39.4854C183.148 39.4854 182.039 43.4093 182.153 44.6385",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.551 35.6532L167.578 39.3554L169.305 45.0147L171.742 39.8712L174.078 35.7544L169.51 35.0361L165.551 35.6532Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.578 39.3555L171.742 39.8713",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.332 29.0637C165.332 29.0637 164.557 30.0712 164.114 31.4161C163.671 32.7611 162.896 37.3551 162.896 37.3551C162.896 37.3551 167.212 37.1285 168.316 37.1285C169.42 37.1285 171.19 37.2394 171.523 37.2394C171.856 37.2394 176.833 40.2667 176.833 40.2667C176.833 40.2667 177.718 35.1087 176.724 32.1971C175.729 29.2806 168.982 25.8098 165.327 29.0589L165.332 29.0637Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.659 35.4219L169.41 39.153L172.969 35.0845C172.969 35.0845 169.653 36.092 167.659 35.4219Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.491 77.4912L180.787 80.6921C180.787 80.6921 178.675 81.1356 178.451 81.5839C178.227 82.0322 177.123 83.9363 176.571 84.4955C176.019 85.0547 174.911 85.8404 175.91 86.2887C176.905 86.7371 178.675 84.7172 178.675 84.7172L179.669 84.1581C179.669 84.1581 179.817 85.4307 179.346 86.8046C178.694 88.699 177.942 91.0033 178.042 91.2443C178.532 92.4494 179.303 91.5962 179.303 91.5962L180.787 88.082L181.049 87.9133C181.049 87.9133 180.749 91.9288 180.749 91.9481C180.692 92.6856 181.335 93.5437 181.896 92.7917L183.224 88.5351V92.3675C183.224 92.9556 183.761 93.4473 184.323 93.2882C184.366 93.2786 184.404 93.2641 184.442 93.2448C184.884 93.0183 185.037 88.3471 185.037 88.3471L185.96 91.7312C186.06 92.0975 186.45 92.3337 186.797 92.1891C186.888 92.1506 186.954 92.0975 186.983 92.0108C187.092 91.6733 186.764 86.2936 186.764 86.2936L186.545 80.6921L186.878 78.7879L182.5 77.496L182.491 77.4912Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.585 39.9343C184.585 39.9343 182.814 43.7426 183.038 45.0875C183.257 46.4325 188.415 59.2889 188.415 59.2889L182.005 78.0024L187.092 79.2364C187.092 79.2364 195.786 66.1438 196.709 63.3285C197.485 60.9665 197.37 59.072 197.37 58.3971C197.37 57.7222 195.315 42.4025 194.097 39.7126C192.878 37.0227 191.332 35.3403 191.332 35.3403",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.585 39.9343C184.585 39.9343 182.814 43.7426 183.038 45.0875C183.257 46.4325 188.415 59.2889 188.415 59.2889L182.005 78.0024L187.092 79.2364C187.092 79.2364 195.786 66.1438 196.709 63.3285C197.485 60.9665 197.37 59.072 197.37 58.3971C197.37 57.7222 195.315 42.4025 194.097 39.7126C192.878 37.0227 191.332 35.3403 191.332 35.3403",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.186 58.8406C189.186 58.8406 191.175 56.0398 192.393 54.2466",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.065 53.2393L189.628 56.3774",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.443 76.209L187.868 77.5539",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.012 44.5425C146.641 44.8655 146.142 45.3668 145.642 46.0995C144.647 47.5554 145.199 50.6935 145.866 51.701C146.527 52.7085 149.182 53.3834 149.182 53.3834H170.666L171.099 49.7053C170.642 49.6957 170.319 49.686 170.319 49.686C170.319 49.686 166.446 48.452 163.681 47.6662C160.916 46.8805 155.473 44.5521 153.836 44.1906C152.323 43.858 150.962 43.9158 150.024 44.0412",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.012 44.5425C146.641 44.8655 146.142 45.3668 145.642 46.0995C144.647 47.5554 145.199 50.6935 145.866 51.701C146.527 52.7085 149.182 53.3834 149.182 53.3834H170.666L171.099 49.7053C170.642 49.6957 170.319 49.686 170.319 49.686C170.319 49.686 166.446 48.452 163.681 47.6662C160.916 46.8805 155.473 44.5521 153.836 44.1906C152.323 43.858 150.962 43.9158 150.024 44.0412",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.287 53.3837L174.178 53.2439C174.178 53.2439 176.41 53.0366 176.714 52.9353C177.019 52.8341 177.932 52.7281 177.932 52.7281L181.159 53.3837H184.361L184.028 52.8245L181.149 51.0312L178.684 49.7827C176.119 48.486 173.036 50.0864 170.309 49.6863C170.309 49.6863 170.761 49.7538 170.823 49.7538L170.395 53.3837H174.287Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.751 50.877L183.823 53.1426",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.901 49.5415L168.763 53.2726",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.671 22.6717C164.671 22.6717 163.234 20.7676 163.124 18.4104C163.015 16.0531 164.119 15.6096 164.119 15.6096C164.119 15.6096 162.458 12.9197 166.108 11.353C169.757 9.78636 175.291 8.88974 178.389 10.5673C181.487 12.2497 182.591 16.1688 182.481 18.8587C182.372 21.5485 180.821 24.6867 180.821 24.6867L178.389 27.7141C178.389 27.7141 176.843 28.2732 176.51 27.6032C176.176 26.9331 174.297 24.9133 173.302 24.9133C172.308 24.9133 169.762 24.9133 168.435 24.3541C167.107 23.7949 164.675 22.6717 164.675 22.6717H164.671Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.447 19.3119C164.447 19.3119 164.338 26.1475 164.338 27.6033C164.338 29.0591 164.338 30.5197 164.999 31.9755C165.66 33.4313 166.217 37.3553 169.201 37.577C172.184 37.7988 176.5 34.6654 177.276 32.983C178.051 31.3006 178.494 28.389 178.494 28.389C178.494 28.389 181.149 26.5958 181.592 24.4651C182.034 22.3344 181.149 21.3269 180.597 22.3344C180.045 23.3419 179.269 25.9209 178.936 26.1426C178.603 26.3692 178.161 24.7977 178.161 24.7977C178.161 24.7977 176.5 25.4726 176.281 24.7977C176.062 24.1228 177.166 20.8738 177.166 20.8738C177.166 20.8738 173.517 21.8813 172.741 21.8813C171.965 21.8813 170.309 21.3221 170.309 21.3221L173.517 23.3371C173.517 23.3371 171.304 24.3446 169.091 23.6745C166.879 22.9996 165.218 19.3022 165.218 19.3022H164.442L164.447 19.3119Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.768 26.4849V27.8298C167.768 27.8298 166.331 31.6381 166.55 32.3129C166.769 32.9878 168.763 32.6504 169.205 32.4238",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.768 26.4849V27.8298C167.768 27.8298 166.331 31.6381 166.55 32.3129C166.769 32.9878 168.763 32.6504 169.205 32.4238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.545 33.4312C167.545 33.4312 169.648 34.7761 171.861 33.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.545 33.4312C167.545 33.4312 169.648 34.7761 171.861 33.542",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.757 28.3892C170.757 28.3892 172.417 29.7341 174.63 28.9483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.757 28.3892C170.757 28.3892 172.417 29.7341 174.63 28.9483",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.866 26.3739C170.866 26.3739 173.298 25.4773 174.849 27.1597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.866 26.3739C170.866 26.3739 173.298 25.4773 174.849 27.1597",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.223 26.5957C165.223 26.5957 165.665 27.6032 167.768 27.8298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.223 26.5957C165.223 26.5957 165.665 27.6032 167.768 27.8298",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.326 25.4774C167.326 25.4774 166.55 24.1324 165.446 24.5808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.326 25.4774C167.326 25.4774 166.55 24.1324 165.446 24.5808",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.305 45.0151L166.16 73.5047L170.219 79.2653L173.978 73.5047L169.305 45.0151Z",
    fill: "#F8F2AD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2529 114.426V119.117C47.2529 119.117 94.6369 117.155 152.132 116.181L47.2529 114.426Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.137 87.084H44.6406V116.181H152.137V87.084Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.474 94.5845C127.946 94.5845 128.145 94.8641 128.145 95.3268V95.6932C128.145 96.1753 127.922 96.4259 127.446 96.4259H127.151V97.6214H126.818V94.5845H127.474ZM127.451 96.1174C127.698 96.1174 127.817 96.0017 127.817 95.7077V95.3027C127.817 95.0231 127.717 94.8882 127.474 94.8882H127.156V96.1174H127.451Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.078 94.5849C129.549 94.5849 129.744 94.8259 129.744 95.2791V95.5249C129.744 95.8575 129.63 96.0648 129.373 96.1516C129.649 96.2335 129.749 96.4601 129.749 96.7831V97.2555C129.749 97.3905 129.749 97.5158 129.811 97.6219H129.473C129.435 97.5351 129.416 97.458 129.416 97.2507V96.7734C129.416 96.4312 129.259 96.3203 128.978 96.3203H128.74V97.617H128.407V94.5801H129.073L129.078 94.5849ZM128.992 96.0166C129.259 96.0166 129.416 95.9298 129.416 95.602V95.3128C129.416 95.038 129.316 94.8982 129.069 94.8982H128.745V96.0214H128.992V96.0166Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.073 95.3178C130.073 94.855 130.301 94.5562 130.758 94.5562C131.215 94.5562 131.448 94.855 131.448 95.3178V96.8893C131.448 97.3473 131.219 97.651 130.758 97.651C130.296 97.651 130.073 97.3473 130.073 96.8893V95.3178ZM130.401 96.9038C130.401 97.1834 130.515 97.3424 130.758 97.3424C131 97.3424 131.115 97.1834 131.115 96.9038V95.2985C131.115 95.0237 131.005 94.8598 130.758 94.8598C130.51 94.8598 130.401 95.0237 130.401 95.2985V96.9038Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.085 95.3177V95.5781H132.766V95.2985C132.766 95.0237 132.661 94.8598 132.414 94.8598C132.166 94.8598 132.062 95.0237 132.062 95.2985V96.9037C132.062 97.1785 132.171 97.3424 132.414 97.3424C132.656 97.3424 132.766 97.1785 132.766 96.9037V96.2963H132.456V95.9926H133.08V96.8844C133.08 97.3424 132.866 97.6461 132.404 97.6461C131.943 97.6461 131.733 97.3424 131.733 96.8844V95.3129C131.733 94.855 131.947 94.5513 132.404 94.5513C132.861 94.5513 133.08 94.855 133.08 95.3129L133.085 95.3177Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.07 94.5849C134.541 94.5849 134.736 94.8259 134.736 95.2791V95.5249C134.736 95.8575 134.622 96.0648 134.365 96.1516C134.641 96.2335 134.741 96.4601 134.741 96.7831V97.2555C134.741 97.3905 134.741 97.5158 134.802 97.6219H134.465C134.426 97.5351 134.407 97.458 134.407 97.2507V96.7734C134.407 96.4312 134.25 96.3203 133.97 96.3203H133.732V97.617H133.399V94.5801H134.065L134.07 94.5849ZM133.984 96.0166C134.25 96.0166 134.407 95.9298 134.407 95.602V95.3128C134.407 95.038 134.307 94.8982 134.06 94.8982H133.736V96.0214H133.984V96.0166Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.159 95.9294V96.2331H135.426V97.3129H136.325V97.6214H135.093V94.5845H136.325V94.893H135.426V95.9294H136.159Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.929 95.3129V95.3949H137.61V95.2936C137.61 95.0189 137.505 94.8598 137.267 94.8598C137.029 94.8598 136.925 95.0189 136.925 95.2888C136.925 95.9685 137.933 96.036 137.933 96.8892C137.933 97.3472 137.714 97.6509 137.258 97.6509C136.801 97.6509 136.587 97.352 136.587 96.8892V96.7157H136.901V96.9085C136.901 97.1833 137.01 97.3424 137.253 97.3424C137.496 97.3424 137.605 97.1833 137.605 96.9085C137.605 96.2336 136.601 96.1662 136.601 95.3129C136.601 94.8453 136.815 94.5513 137.267 94.5513C137.719 94.5513 137.933 94.8501 137.933 95.3129H137.929Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.523 95.3129V95.3949H139.204V95.2936C139.204 95.0189 139.099 94.8598 138.861 94.8598C138.623 94.8598 138.519 95.0189 138.519 95.2888C138.519 95.9685 139.527 96.036 139.527 96.8892C139.527 97.3472 139.309 97.6509 138.852 97.6509C138.395 97.6509 138.181 97.352 138.181 96.8892V96.7157H138.495V96.9085C138.495 97.1833 138.604 97.3424 138.847 97.3424C139.09 97.3424 139.199 97.1833 139.199 96.9085C139.199 96.2336 138.195 96.1662 138.195 95.3129C138.195 94.8453 138.409 94.5513 138.861 94.5513C139.313 94.5513 139.527 94.8501 139.527 95.3129H139.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.99 94.5845C106.457 94.5845 106.671 94.8689 106.671 95.3413V96.8742C106.671 97.337 106.457 97.6262 105.99 97.6262H105.286V94.5893H105.99V94.5845ZM105.986 97.3129C106.224 97.3129 106.342 97.1635 106.342 96.8839V95.322C106.342 95.0424 106.228 94.893 105.981 94.893H105.619V97.3129H105.981H105.986Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.051 95.9294V96.2331H107.318V97.3129H108.217V97.6214H106.985V94.5845H108.217V94.893H107.318V95.9294H108.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.864 97.0092L108.75 97.6214H108.441L109.017 94.5845H109.502L110.078 97.6214H109.745L109.631 97.0092H108.874H108.864ZM108.907 96.7152H109.573L109.236 94.9605L108.907 96.7152Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.039 94.5845C111.505 94.5845 111.719 94.8689 111.719 95.3413V96.8742C111.719 97.337 111.505 97.6262 111.039 97.6262H110.335V94.5893H111.039V94.5845ZM111.034 97.3129C111.272 97.3129 111.391 97.1635 111.391 96.8839V95.322C111.391 95.0424 111.277 94.893 111.029 94.893H110.668V97.3129H111.029H111.034Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.029 97.6214V94.5845H112.362V97.3129H113.218V97.6214H112.029Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.808 94.5845V97.6214H113.475V94.5845H113.808Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.446 97.6214H114.146V94.5845H114.57L115.264 96.7827V94.5845H115.559V97.6214H115.212L114.446 95.1629V97.6214Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.968 95.9294V96.2331H116.235V97.3129H117.134V97.6214H115.902V94.5845H117.134V94.893H116.235V95.9294H116.968Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2859 98.0557H92.5432",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5094 98.0557H84.0305",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 98.0557H65.0017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0214 105.267H81.8083",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7543 105.267H73.0148",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7444 105.267H62.2513",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.97 105.267H56.7411",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.154 103.922C148.154 104.554 147.902 105.123 147.498 105.532C147.088 105.942 146.527 106.198 145.908 106.198H122.331C121.089 106.198 120.08 105.18 120.08 103.922C120.08 103.291 120.332 102.722 120.741 102.312C121.146 101.898 121.707 101.642 122.331 101.642H145.908C147.15 101.642 148.154 102.664 148.154 103.922Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.617 106.198H106.314C105.072 106.198 104.068 105.176 104.068 103.922C104.068 102.664 105.077 101.647 106.314 101.647H115.617C116.859 101.647 117.863 102.669 117.863 103.922C117.863 105.18 116.854 106.198 115.617 106.198Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1193 120.939C54.1193 120.939 55.7086 116.75 56.0274 116.321C56.3462 115.892 56.8744 114.817 57.8308 114.817C58.7872 114.817 60.4812 114.923 61.2235 114.6C61.9658 114.277 62.9175 114.277 62.7081 114.923C62.4988 115.569 61.2235 115.781 61.2235 115.781L66.7385 116.21C66.7385 116.21 65.1492 117.714 64.4069 118.037C63.6646 118.36 62.0753 118.683 62.0753 118.683C62.0753 118.683 60.8048 119.541 59.953 119.758C59.1013 119.975 57.8308 120.081 57.8308 120.081L56.665 122.231L54.1193 120.944V120.939Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2235 115.781L58.7872 116.427",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9766 102.356L39.1732 105.47L40.2343 107.943L43.1988 105.687L44.6834 104.612V98.1665L40.9766 102.356Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5484 104.077C40.5484 104.077 41.3954 99.6754 41.8189 99.1355C42.2424 98.5956 43.9411 97.3085 44.4693 97.2025C44.9975 97.0964 45.7398 97.4194 45.3163 98.0606C44.8928 98.7065 43.5128 99.6706 43.5128 99.6706C43.5128 99.6706 44.2551 101.821 43.727 103.002C43.1988 104.183 42.033 104.718 42.033 104.718",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5484 104.077C40.5484 104.077 41.3954 99.6754 41.8189 99.1355C42.2424 98.5956 43.9411 97.3085 44.4693 97.2025C44.9975 97.0964 45.7398 97.4194 45.3163 98.0606C44.8928 98.7065 43.5128 99.6706 43.5128 99.6706C43.5128 99.6706 44.2551 101.821 43.727 103.002C43.1988 104.183 42.033 104.718 42.033 104.718",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2779 104.612L41.0813 109.23L31.8548 116.321L29.842 109.018L39.2779 104.612Z",
    fill: "#F8F2AD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0762 182.083L35.4331 186.663C35.4331 186.663 33.0539 191.724 33.2918 196.183C33.5298 200.642 34.0056 213.537 34.0056 214.26C34.0056 214.983 32.816 215.827 33.6487 218.84C33.8819 219.679 35.909 219.081 37.9313 220.406C39.9536 221.732 42.4517 222.576 43.9982 222.576C45.5447 222.576 46.3774 222.576 46.3774 221.853C46.3774 221.13 44.1172 220.165 43.1655 219.201C42.2138 218.237 39.2398 214.26 39.0019 213.778C38.764 213.296 39.8346 206.186 40.5484 203.414C41.2621 200.642 43.2844 194.014 44.1172 189.314C44.9499 184.614 45.3068 180.757 45.3068 180.757L35.0762 182.083Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6487 218.84L33.8866 222.094H35.5521L36.2658 219.442C36.2658 219.442 34.2435 218.719 33.6487 218.84Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9982 222.576C45.5352 222.417 46.3774 222.576 46.3774 221.853C46.3774 221.13 44.1172 220.165 43.1655 219.201C42.4232 218.449 40.4627 215.88 39.5158 214.549C39.0638 214.892 38.488 215.181 37.8123 215.224C36.0279 215.345 34.0056 214.26 34.0056 214.26C34.0056 214.983 32.816 215.827 33.6487 218.84C33.8819 219.679 35.9756 219.529 37.6077 221.51C39.1494 223.386 43.765 222.595 43.9982 222.576Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.158 178.588L21.3959 185.337C21.3959 185.337 18.3029 189.555 17.7081 193.652C17.1133 197.75 15.091 213.778 15.091 215.345C15.091 216.911 14.1394 221.973 14.6152 222.335C15.091 222.696 20.5632 222.335 20.5632 222.335C20.5632 222.335 20.8011 221.852 20.8011 220.647C20.8011 219.442 19.8494 215.465 20.0873 214.501C20.3253 213.537 21.158 210.524 21.158 210.524C21.158 210.524 24.8457 200.763 26.3922 197.75C27.9387 194.737 29.2472 190.398 30.0799 187.747C30.9126 185.096 31.6264 181.36 31.6264 181.36L21.158 178.588Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0635 214.684C18.4124 212.332 15.7144 213.768 15.1862 214.082C15.1291 214.704 15.091 215.142 15.091 215.345C15.091 216.911 14.1394 221.973 14.6152 222.335C15.091 222.696 20.5632 222.335 20.5632 222.335C20.5632 222.335 20.8011 221.852 20.8011 220.647C20.8011 219.505 19.9493 215.885 20.0588 214.684H20.0635Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5632 222.335C20.3253 221.612 18.6598 218.719 18.6598 218.719L15.5669 218.84C14.4962 220.045 14.6152 222.335 14.6152 222.335C15.091 222.696 20.5632 222.335 20.5632 222.335Z",
    fill: "#8C8C8C",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6598 218.719C18.6598 218.719 17.5892 217.755 16.7565 218.117C15.9238 218.478 15.5669 218.84 15.5669 218.84L15.6858 222.455H17.8271L18.6598 218.719Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5409 154.605C18.5409 154.605 17.5892 157.016 17.4702 160.149C17.3513 163.282 18.184 178.708 18.184 178.708C18.184 178.708 24.132 182.806 34.1246 183.167C44.1172 183.529 48.7566 180.757 48.7566 180.757C48.7566 180.757 48.5187 162.198 47.3291 157.739C46.1395 153.28 43.9982 151.472 43.9982 151.472C43.9982 151.472 39.2398 152.918 31.9833 152.798C24.7268 152.677 19.7305 151.352 19.7305 151.352L18.5409 154.605Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6814 117.502C21.6814 117.502 18.7122 123.089 18.2887 127.167C17.8652 131.25 21.7861 143.706 21.7861 144.135C21.7861 144.564 17.651 155.305 17.651 155.305C17.651 155.305 22.4237 157.454 27.7245 158.636C33.0254 159.817 38.4309 159.065 39.492 158.742L40.8719 154.553L41.4001 158.096C41.4001 158.096 41.4001 158.202 43.0941 157.773C44.7881 157.344 46.9103 155.517 46.9103 155.517C46.9103 155.517 44.1552 148.965 42.7753 147.138C41.3954 145.311 39.7014 141.122 39.7014 141.122L40.339 135.752C40.339 135.752 45.1117 139.724 45.5351 139.835C45.9586 139.946 52.53 132.103 53.9099 129.847C55.2898 127.591 57.5167 121.792 57.5167 121.792L54.3382 120.182L53.0677 121.469L45.5399 129.741C45.5399 129.741 40.9814 124.477 38.7545 123.619C36.5275 122.761 32.2878 121.469 32.2878 121.469L23.6989 119.43L24.3366 117.603C24.3366 117.603 23.9131 116.316 21.6862 117.497L21.6814 117.502Z",
    fill: "#F8F2AD",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.339 135.757L35.5521 132.913L39.9108 138.249L40.339 135.757Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2893 142.405C30.7604 142.959 31.2505 143.46 31.7501 143.88",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4508 131.915C24.4508 131.915 26.4969 137.256 29.3138 141.161",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.711 140.009C26.711 140.009 28.1004 142.472 30.708 145.287",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4617 100.64C35.4617 100.64 35.9898 101.609 36.4181 103.325C36.8464 105.041 38.3262 105.904 38.8544 105.793C39.3826 105.682 39.3826 106.974 39.0685 107.62C38.7545 108.266 38.2215 108.801 38.2215 108.801C38.2215 108.801 38.1168 111.38 37.798 113.313C37.4792 115.246 37.3745 116.75 36.6322 116.75H32.816C32.816 116.75 32.4972 118.466 32.3925 119.864C32.2878 121.262 32.2878 121.474 32.2878 121.474L23.699 119.435L24.6554 116.427C24.6554 116.427 19.2499 113.959 21.9003 109.447C24.5507 104.935 30.808 99.2417 35.4712 100.64H35.4617Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8112 116.75L31.0554 116.605L32.4449 119.069L32.8112 116.75Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0074 111.163C38.0074 111.163 37.1604 111.809 35.8852 111.269",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7194 104.506C34.7194 104.506 34.9335 102.467 35.9898 102.573",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3991 105.354C36.5799 105.918 36.5656 106.429 36.3705 106.492C36.1754 106.554 35.8709 106.149 35.6948 105.585C35.514 105.021 35.5283 104.51 35.7234 104.448C35.9185 104.385 36.223 104.79 36.3991 105.354Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4617 97.4147C35.4617 97.4147 35.4855 97.4484 35.4997 97.4629C36.6227 98.9428 36.4324 100.591 35.5664 102.139C33.8058 105.296 28.4193 108.232 28.4193 110.845C28.4193 113.458 31.1315 113.318 31.1315 113.318C31.1315 113.318 32.2165 115.651 29.5042 117.714C26.7919 119.772 21.2341 120.322 17.7082 116.615C16.6803 115.535 16.038 114.219 15.6478 112.893C14.5771 109.278 14.4249 105.253 15.9999 101.975C17.3227 99.2272 18.8454 97.0001 21.61 95.6214C23.7798 94.5416 27.2059 94.2716 29.6279 94.4114C30.7985 94.4789 31.9881 94.72 33.0444 95.2502C33.9295 95.6937 34.8526 96.6241 35.4617 97.4098V97.4147Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0481 115.535C28.9332 115.386 29.5756 115.102 29.5756 115.102",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.678 103.484C32.0356 104.429 31.1553 105.412 29.9515 106.27C26.2161 108.921 22.1049 111.698 23.9702 114.219C24.7077 115.217 25.7403 115.564 26.7158 115.617",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3101 99.7046C34.3101 99.7046 34.1626 100.62 33.5916 101.864",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3929 107.133C24.7886 107.987 24.0178 108.989 23.0994 110.055C20.4823 113.082 20.8582 119.267 26.711 118.765",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0869 104.501C27.0869 104.501 26.8109 105.007 26.2685 105.841",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.221 164.546C181.468 165.095 184.513 165.028 184.518 165.028C184.551 165.028 183.861 163.008 183.804 162.883C183.138 161.466 181.021 159.128 179.303 159.364C178.066 159.532 177.376 160.791 177.652 161.972C177.937 163.182 179.16 164.078 180.221 164.546Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.139 154.042C218.412 153.854 216.361 156.249 215.733 157.686C215.681 157.811 215.048 159.85 215.076 159.85C215.076 159.85 215.105 159.85 215.114 159.85C214.786 160.226 214.443 160.631 214.072 161.085C213.397 161.923 212.64 162.883 211.888 163.977C211.132 165.071 210.342 166.281 209.623 167.631C208.9 168.985 208.21 170.441 207.691 172.042C207.686 172.061 207.682 172.08 207.677 172.099C207.686 171.584 207.663 170.142 207.648 170.031C207.449 168.474 206.159 165.582 204.456 165.264C203.228 165.033 202.186 166.011 202.086 167.221C201.986 168.46 202.871 169.699 203.737 170.48C204.712 171.362 207.415 172.215 207.629 172.283C207.149 173.811 206.778 175.416 206.487 177.06C206.321 178 206.183 178.954 206.059 179.909C206.054 179.465 206.045 179.065 206.035 179.007C205.835 177.45 204.546 174.558 202.842 174.24C201.615 174.008 200.573 174.987 200.473 176.197C200.373 177.436 201.258 178.675 202.124 179.456C202.999 180.246 205.288 181.022 205.897 181.22C205.854 181.586 205.802 181.953 205.759 182.324C205.55 184.088 205.35 185.853 205.103 187.574C205.017 188.181 204.908 188.774 204.803 189.372C204.798 188.976 204.789 188.644 204.784 188.591C204.584 187.034 203.294 184.141 201.591 183.823C200.359 183.592 199.321 184.57 199.221 185.78C199.121 187.019 200.006 188.258 200.872 189.039C201.71 189.796 203.818 190.529 204.536 190.77C204.408 191.377 204.284 191.984 204.132 192.568C204.023 192.963 203.942 193.349 203.808 193.739C203.685 194.129 203.561 194.515 203.442 194.896C203.18 195.624 202.919 196.371 202.643 197.075C202.457 197.567 202.271 198.029 202.086 198.497C202.181 197.894 202.338 196.708 202.343 196.607C202.367 195.566 202 193.869 201.272 192.674C201.272 192.519 201.272 192.365 201.244 192.216C201.053 191.015 199.94 190.124 198.731 190.451C197.051 190.905 195.99 193.888 195.909 195.455C195.909 195.547 195.967 196.559 196.014 197.195C195.929 196.824 195.852 196.467 195.762 196.087C195.586 195.335 195.391 194.592 195.181 193.787C195.067 193.402 194.953 193.016 194.834 192.625C194.725 192.235 194.563 191.835 194.43 191.435C194.097 190.514 193.716 189.598 193.316 188.687C193.968 188.528 196.262 187.935 197.185 187.217C198.103 186.503 199.079 185.332 199.069 184.093C199.06 182.878 198.094 181.827 196.852 181.962C195.124 182.15 193.625 184.937 193.316 186.474C193.297 186.571 193.192 187.699 193.15 188.321C192.902 187.776 192.66 187.226 192.393 186.682C191.622 185.105 190.794 183.539 189.971 181.972C189.719 181.49 189.476 181.008 189.229 180.531C189.462 180.478 192.207 179.832 193.24 179.027C194.158 178.313 195.134 177.147 195.124 175.903C195.115 174.688 194.149 173.637 192.907 173.772C191.18 173.96 189.681 176.747 189.371 178.284C189.348 178.4 189.205 180.025 189.186 180.439C188.643 179.379 188.111 178.318 187.63 177.248C186.964 175.773 186.388 174.293 185.936 172.813C186.045 172.789 188.915 172.128 189.971 171.304C190.889 170.591 191.865 169.424 191.855 168.18C191.846 166.966 190.88 165.915 189.638 166.05C187.911 166.238 186.417 169.024 186.102 170.562C186.079 170.682 185.922 172.432 185.917 172.75C185.888 172.664 185.855 172.577 185.826 172.485C185.365 170.899 185.113 169.308 184.946 167.804C184.851 166.932 184.803 166.093 184.78 165.274C185.327 165.206 187.82 164.869 188.858 164.237C189.847 163.63 190.942 162.579 191.07 161.34C191.194 160.13 190.347 158.978 189.095 158.973C187.359 158.973 185.57 161.571 185.089 163.066C185.065 163.148 184.889 164.001 184.77 164.628C184.765 164.256 184.751 163.876 184.751 163.524C184.751 162.193 184.837 160.974 184.918 159.899C184.97 159.286 185.027 158.732 185.089 158.216C185.593 157.864 187.597 156.433 188.215 155.406C188.819 154.403 189.31 152.957 188.862 151.805C188.42 150.672 187.145 150.045 186.036 150.629C184.494 151.439 184.09 154.582 184.342 156.129C184.366 156.264 184.946 158.317 184.975 158.298C184.975 158.298 184.999 158.279 185.003 158.279C184.937 158.775 184.87 159.306 184.808 159.889C184.703 160.969 184.594 162.188 184.561 163.524C184.527 164.859 184.527 166.31 184.661 167.838C184.794 169.371 185.013 170.971 185.451 172.596C185.455 172.615 185.465 172.635 185.47 172.649C185.198 172.215 184.394 171.025 184.323 170.943C183.309 169.757 180.659 168.065 179.06 168.749C177.909 169.246 177.571 170.639 178.151 171.704C178.741 172.794 180.154 173.329 181.301 173.497C182.596 173.69 185.313 172.89 185.531 172.823C185.96 174.365 186.526 175.913 187.183 177.446C187.559 178.323 187.958 179.195 188.377 180.063C188.13 179.697 187.906 179.369 187.868 179.326C186.854 178.14 184.204 176.448 182.605 177.137C181.454 177.634 181.116 179.027 181.696 180.092C182.286 181.181 183.699 181.717 184.846 181.885C186.007 182.059 188.339 181.422 188.957 181.249C189.119 181.582 189.281 181.914 189.443 182.247C190.228 183.838 191.023 185.419 191.755 186.995C192.012 187.549 192.246 188.109 192.483 188.663C192.265 188.335 192.074 188.065 192.041 188.022C191.027 186.836 188.377 185.144 186.778 185.828C185.627 186.325 185.289 187.718 185.869 188.783C186.459 189.873 187.873 190.408 189.019 190.577C190.128 190.741 192.288 190.177 193.016 189.969C193.24 190.548 193.468 191.121 193.659 191.69C193.782 192.081 193.925 192.452 194.025 192.852C194.135 193.247 194.239 193.638 194.349 194.023C194.525 194.775 194.715 195.547 194.872 196.284C194.986 196.795 195.082 197.287 195.181 197.779C194.929 197.224 194.42 196.144 194.368 196.063C193.545 194.732 191.18 192.654 189.495 193.088C188.282 193.402 187.739 194.727 188.153 195.87C188.572 197.036 189.89 197.783 190.999 198.126C192.217 198.502 194.915 198.159 195.253 198.111C195.415 198.926 195.562 199.726 195.695 200.478C195.89 201.611 196.057 202.662 196.19 203.616H194.615V222.658H202.086V203.616H201.096C201.391 202.932 201.696 202.204 202.01 201.423C202.329 200.642 202.652 199.798 202.976 198.931C203.304 198.998 205.973 199.548 207.22 199.263C208.348 199.003 209.718 198.357 210.223 197.224C210.718 196.116 210.275 194.751 209.09 194.346C207.444 193.787 204.931 195.682 204.013 196.945C203.961 197.017 203.456 197.894 203.152 198.454C203.285 198.097 203.413 197.755 203.542 197.388C203.804 196.665 204.046 195.932 204.308 195.147C204.422 194.761 204.536 194.375 204.651 193.985C204.774 193.599 204.855 193.175 204.96 192.765C205.184 191.811 205.364 190.837 205.526 189.849C206.154 190.08 208.395 190.871 209.552 190.789C210.708 190.707 212.155 190.278 212.826 189.237C213.482 188.219 213.249 186.802 212.136 186.219C210.594 185.414 207.824 186.899 206.725 188.007C206.659 188.075 205.954 188.962 205.583 189.454C205.674 188.861 205.769 188.268 205.845 187.665C206.059 185.92 206.221 184.151 206.392 182.382C206.445 181.842 206.502 181.302 206.559 180.762C206.782 180.849 209.423 181.842 210.722 181.75C211.879 181.668 213.325 181.239 213.996 180.198C214.653 179.181 214.42 177.764 213.306 177.18C211.764 176.375 208.995 177.86 207.901 178.969C207.82 179.051 206.811 180.328 206.573 180.666C206.697 179.475 206.83 178.294 207.011 177.132C207.253 175.532 207.582 173.975 208.01 172.485C208.115 172.524 210.865 173.579 212.197 173.483C213.354 173.401 214.8 172.972 215.471 171.931C216.128 170.914 215.895 169.496 214.781 168.913C213.24 168.108 210.47 169.593 209.376 170.702C209.29 170.788 208.21 172.162 208.029 172.422C208.053 172.336 208.072 172.239 208.1 172.153C208.576 170.571 209.233 169.101 209.918 167.756C210.313 166.975 210.732 166.247 211.16 165.553C211.655 165.804 213.92 166.917 215.124 166.966C216.28 167.014 217.769 166.749 218.545 165.785C219.306 164.845 219.23 163.408 218.188 162.709C216.742 161.735 213.83 162.907 212.621 163.885C212.554 163.938 211.945 164.555 211.507 165.008C211.703 164.695 211.902 164.372 212.093 164.078C212.821 162.969 213.554 162 214.205 161.147C214.581 160.665 214.933 160.236 215.262 159.841C215.871 159.831 218.326 159.754 219.402 159.243C220.448 158.747 221.648 157.816 221.9 156.601C222.147 155.411 221.424 154.177 220.182 154.037L220.139 154.042ZM201.03 201.023C200.625 201.963 200.24 202.826 199.873 203.621H197.266C197.099 202.614 196.904 201.505 196.666 200.29C196.504 199.461 196.319 198.574 196.114 197.668C196.319 197.586 197.47 197.113 198.489 196.535C199.378 197.509 201.653 198.651 201.948 198.796C201.639 199.567 201.329 200.314 201.025 201.018L201.03 201.023Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.046 165.226C211.074 165.245 211.598 163.172 211.617 163.042C211.831 161.485 211.341 158.351 209.775 157.59C208.648 157.04 207.391 157.701 206.982 158.843C206.563 160.01 207.096 161.441 207.725 162.425C208.462 163.582 211.041 165.226 211.046 165.226Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.219 222.523H227.248",
    stroke: "#F8F2AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.066 222.523H218.445",
    stroke: "#F8F2AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98351 222.523H214.348",
    stroke: "#F8F2AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 216,
    fill: "white",
    transform: "translate(3 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAssignment);
export default __webpack_public_path__ + "static/media/admin-assignment.d1ddb9d160710b9f7d76414a1155f3f4.svg";
export { ForwardRef as ReactComponent };